import _sfc_main from "./ProfileDropdown.vue2.js";
/* empty css                     */
/* empty css                     */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const ProfileDropdown = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-386aa77c"]]);
export {
  ProfileDropdown as default
};
//# sourceMappingURL=ProfileDropdown.vue.js.map
